module.exports = __webpack_public_path__ + "static/media/9-ball.2d2c3b11.png";